define((require) => {
    "use strict";

    const CompositeWidgetCollectionView = require("shared/ui/experience/widgets/compositeWidget/CompositeWidgetCollectionView");

    return CompositeWidgetCollectionView.extend({

        className: "widget-container-inner dynamic-product-collection"

    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetCollectionView.js